export var EmoteStreamType = /*#__PURE__*/ function(EmoteStreamType) {
    EmoteStreamType["OFFICIAL"] = "official";
    EmoteStreamType["COMMUNITY"] = "community";
    EmoteStreamType["SEARCH"] = "search";
    EmoteStreamType["USER"] = "user";
    return EmoteStreamType;
}({});

//# sourceMappingURL=types.js.map